import React from "react";
import ReportCompetencyContent from "./ReportCompetencyContent";
import ReportOtherContent from "./ReportOtherContent";

export default function ReportSecondaryCategoryContent({
  category,
  statistic,
  period,
  reportId,
  mode,
  loading = false,
  loadError = false,
}) {
  if (category === "materials") {
    return (
      <ReportCompetencyContent
        statistic={statistic}
        period={period}
        reportId={reportId}
        mode={mode}
      />
    );
  }

  return (
    <ReportOtherContent
      statistic={statistic}
      period={period}
      loading={loading}
      loadError={loadError}
    />
  );
}
